import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { freeDaysActions } from '../../../actions/freeDaysActions';

import {
    Paper,
    Modal,
    CircularProgress,
    withStyles
} from '@material-ui/core';

import {
    pageModes,
    freeDayReference,
    styleWithCommonClasses,
    tabDisplays
} from '../../../_constants/emparkConstants'

import TitleToolbar from '../../Forms/TitleToolbar';

import translate from '../../../locales';
import FreeDayForm from '../../Forms/FreeDayForm';
import { toDateJsonString, toDateString } from '../../../_helpers/dateConvert';
import { municipalitiesActions } from '../../../actions/municipalitiesActions';
import { contextsActions } from '../../../actions/contextsActions';
import { ratesActions } from '../../../actions/ratesActions';
import ErrorMessage from '../../ErrorMessage';
import LoadingPaper from '../../LoadingPaper';



const __t = translate;

const styles = styleWithCommonClasses();

class FreeDayDetailPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            freeDay: null
        }

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const { reference, router } = this.props;

        let freeDays = [];

        if (reference === freeDayReference.municipality)
            freeDays = this.props.freeDays.municipality;
        else if (reference === freeDayReference.context)
            freeDays = this.props.freeDays.context;
        else
            freeDays = this.props.freeDays.rate;

        if (router.mode !== pageModes.add) {
            this.setState({
                freeDay: freeDays.find(sp => sp.id === router.id)
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.router.mode !== pageModes.add && this.props != prevProps || this.props.router.mode != prevProps.router.mode) {
            const { reference } = this.props;
            let freeDays = [];

            if (reference === freeDayReference.municipality)
                freeDays = this.props.freeDays.municipality;
            else if (reference === freeDayReference.context)
                freeDays = this.props.freeDays.context;
            else
                freeDays = this.props.freeDays.rate;

            this.setState({
                freeDay: freeDays.find(sp => sp.id === this.props.router.id)
            })
        }
    }

    render() {
        const { classes, router, loading } = this.props;

        const title = router.mode === pageModes.add ? __t('create') : router.mode === pageModes.edit ? __t('edit') : __t('view');

        if (loading)
            return (
                <LoadingPaper />
            )

        if (router.mode === pageModes.add || router.mode === pageModes.edit)
            return (
                <Paper
                    className={this.props.classes.paperNoMargins}
                    elevation={0}
                >
                    <TitleToolbar
                        title={`${title} ${__t('free_day')}`}
                        onCancel={() => {
                            this.props.changeTabDisplay(this.props.reference, tabDisplays.index);
                            this.props.changeMode(pageModes.list);
                        }}
                        onSave={this.handleSubmit}
                    >
                        <FreeDayForm
                            locale={this.props.locale}
                            key="free day form 1"
                            freeDay={this.state.freeDay}
                            refReturnData={(returnData) => this.submitForm = returnData}
                        />
                        <ErrorMessage
                            className={this.props.classes.errorText}
                            error={this.props.error}
                        />
                    </TitleToolbar>
                </Paper>
            )

        if (this.state.freeDay == null)
            return (
                <Paper className={classes.paperNoMargins}>
                    <CircularProgress className={this.props.classes.loadingFixedCenter} color="secondary" />
                </Paper>
            )

        return (
            <Paper
                className={classes.paperNoMargins}
                elevation={0}
            >
                <TitleToolbar
                    title={`${title} ${__t('free_day')}`}
                    onEdit={() => this.props.changeMode(pageModes.edit, this.state.freeDay.id)}
                    onBack={() => {
                        this.props.changeTabDisplay(this.props.reference, tabDisplays.index);
                        this.props.changeMode(pageModes.list);
                    }}
                >
                    <FreeDayForm
                        locale={this.props.locale}
                        key="free day form 2"
                        freeDay={this.state.freeDay}
                        refReturnData={(returnData) => this.submitForm = returnData}
                        readonly
                    />
                </TitleToolbar>
            </Paper>
        )
    }

    handleSubmit() {
        var data = this.submitForm();

        let freeDay = {
            ...this.state.freeDay,
            name: data.formData.name,
            dayDate: toDateJsonString(data.formData.dayDate)
        }

        if (this.props.router.mode === pageModes.add) {
            if (this.props.reference === freeDayReference.municipality)
                freeDay.municipalityId = this.props.referenceId;
            else if (this.props.reference === freeDayReference.context)
                freeDay.contextId = this.props.referenceId;
            else
                freeDay.rateId = this.props.referenceId
        }

        this.setState({ freeDay: freeDay });

        if (data.formError) {
            this.props.setError(__t('error_required_fields'));

            return;
        }

        this.props.sendFreeDay(this.props.reference, this.props.referenceId, freeDay);
    };

}

function mapStateToProps(state) {
    return {
        router: state.freeDaysReducer.router,
        freeDays: state.freeDaysReducer.freeDays,
        error: state.freeDaysReducer.error,
        locale: state.locales.current,
        loading: state.freeDaysReducer.loading,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        sendFreeDay: (reference, referenceId, freeDay) => {
            dispatch(freeDaysActions.saveFreeDay(reference, referenceId, freeDay))
        },
        changeMode: (mode, id) => {
            dispatch(freeDaysActions.changeMode(mode, id))
        },
        changeTabDisplay: (reference, tabDisplay) => {
            if (reference === freeDayReference.municipality)
                dispatch(municipalitiesActions.setTabDisplay(tabDisplay))
            else if (reference === freeDayReference.context)
                dispatch(contextsActions.setTabDisplay(tabDisplay))
            else
                dispatch(ratesActions.setTabDisplay(tabDisplay))
        },
        setError: (error) => {
            dispatch(freeDaysActions.setError(error))
        }
    }
}

FreeDayDetailPage.propTypes = {
    freeDays: PropTypes.object.isRequired,
    router: PropTypes.object,
    reference: PropTypes.string,
    referenceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FreeDayDetailPage));